import React, { forwardRef, useState } from "react";
import PerformanceStore from "../../store/PerformanceStore";
import accessibleDropdown from "../AccessibleDropdown/AccessibleDropdown";

//function MenuList({ list, title, onClick, customClass = false })
const MenuList = forwardRef(
  (
    {
      menuItems,
      itemRefs,
      isOpen,
      setIsOpen,
      handleItemKeyDown,
      exportExcel,
      exportPdf,
      handleMenuItemClick,
      restrictHover,
      accessibilityValues,
      onClick,
      customClass = false,
      popupClassName = { open: "", close: "", wrapperClass: "" },
    },
    ref,
  ) => {
    const [selectedIndex, setSelectedIndex] = useState(2);

    const selectOption = ({ item, index }) => {
      setSelectedIndex(index);
      onClick({
        item,
        index,
      });

      handleMenuItemClick(true, true);
    };

    return (
      <div
        className={`list_menu performance-index-menu ${isOpen ? popupClassName.open : popupClassName.close}`}
      >
        <div className="menus_outer_container">
          <div
            ref={ref}
            id={accessibilityValues.ariaControls}
            role={accessibilityValues.ariaHaspopup}
            aria-label={accessibilityValues.ariaLabel}
            aria-labelledby={accessibilityValues.buttonId}
            className="menu_listitem_container"
          >
            {menuItems?.map((item, index) => {
              return (
                <button
                  role="menuitem"
                  ref={(el) => (itemRefs.current[index] = el)}
                  aria-current={selectedIndex === index}
                  onClick={() => {
                    selectOption({ item, index });
                  }}
                  onKeyDown={(e) => handleItemKeyDown(e, index)}
                  className={`listitem ${customClass ? customClass : ""}`}
                >
                  {!!item?.image ? (
                    <div className="icon_wrapper">
                      <img src={item?.image} alt="family access" />
                    </div>
                  ) : (
                    <></>
                  )}
                  <div className="list_btn_performance">
                    <p
                      className={
                        item?.id === PerformanceStore.selectedIndexForApi
                          ? "listitem_text highlightColor"
                          : "listitem_text"
                      }
                    >
                      {item?.fullName}
                    </p>
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    );
  },
);

export default accessibleDropdown(MenuList);
